import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MarkovGroup } from "server/models"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Link,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

import EditGroup from "client/pages/markov/group/edit"
import AssignedGroupStates from "client/pages/markov/groupState/assigned"

const Columns = () => {
    const stateList = useSelector((state: StoreType) => state.markovState.stateList)
    const groupStateList = useSelector((state: StoreType) => state.markovGroupState.groupStateList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (group: MarkovGroup) => (
                editModelAccess
                    ? (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editGroup",
                                content: <EditGroup groupId={group.id} />,
                            }))}
                        >
                            {group.name}
                        </Link>
                    )
                    : group.name
            ),
        },
        {
            field: "description",
            header: lang.description,
        },
        {
            field: "groupStates",
            header: lang.states,
            cellMinWidth: "150px",
            formatter: (group: MarkovGroup) => {
                if (!stateList || !groupStateList) return null

                const stateIds = groupStateList[group.id] || []
                const dataList: TablePopoverData[] = []
                stateIds.forEach((stateId) => {
                    const mState = stateList[stateId]
                    if (mState) {
                        dataList.push({
                            id: `${group.id}_${mState.id}`,
                            title: mState.name,
                        })
                    }
                })

                return (
                    <TablePopover
                        id={`groupStates${group.id}`}
                        dataList={dataList}
                        placement="left"
                        title={lang.states}
                        editAccess={editModelAccess}
                        onClick={() => {
                            dispatch(addModal({
                                key: "assignedGroupStates",
                                content: <AssignedGroupStates groupId={group.id} />,
                            }))
                        }}
                    />
                )
            },
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
    ]

    if (editModelAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
